import React from 'react';
import { motion } from 'framer-motion';
import { Download, Edit3 } from 'lucide-react';
const steps = [{
  number: '1',
  icon: <Download className="w-10 h-10 text-navy" data-id="element-111" />,
  title: 'Descarga e Imprime',
  description: 'Recibes los documentos inmediatamente en tu correo. Puedes imprimirlos en casa o en tu papelería de confianza. El diseño está optimizado para gastar poca tinta pero ser muy legible.'
}, {
  number: '2',
  icon: <Edit3 className="w-10 h-10 text-navy" data-id="element-112" />,
  title: 'Llena con Calma',
  description: 'Siéntate con una taza de café y llena las plantillas a mano, a tu propio ritmo. Nuestro Método Zero-Tech significa que no tienes que aprender a usar ningún programa nuevo.'
}, {
  number: '3',
  icon: <div className="w-10 h-10 text-navy" data-id="element-113" />,
  title: 'Guarda Seguro',
  description: 'Coloca las hojas en una carpeta física junto a tus otros documentos importantes y avísale a tu persona de mayor confianza dónde encontrarla.'
}];
export function HowItWorks() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-116">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-117">
            El Método "Zero-Tech": Tan fácil como usar papel y lápiz
          </h2>
          <p className="text-xl text-navy-light max-w-3xl mx-auto" data-id="element-118">
            Olvídate de aplicaciones complicadas, nubes virtuales o contraseñas
            maestras. Volvemos a lo básico porque es lo más seguro y lo que tu
            familia entenderá mejor.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 relative" data-id="element-119">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gold/30 z-0" data-id="element-120"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-121">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center border-4 border-gold shadow-lg mb-6 relative" data-id="element-122">
                <span className="absolute -top-3 -right-3 w-8 h-8 bg-navy text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-123">
                  {step.number}
                </span>
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-124">
                {step.title}
              </h3>
              <p className="text-lg text-navy-light leading-relaxed" data-id="element-125">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}